<!-- Start Footer Area -->
<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>{{contact}}</h3>

                    <ul class="contact-us-link">

                        <li>
                            <i class='bx bx-phone-call'></i>
                            <a href="#">{{setting.tel}}</a>
                        </li>
                        <li>
                            <i class='bx bx-phone-call'></i>
                            <a href="#">{{setting.phone}}</a>
                        </li>
                        <li>
                            <i class='bx bx-envelope'></i>
                            <a href="#">{{setting.email}}</a>
                        </li>
                        <li>
                            <i class='bx bx-envelope'></i>
                            <a href="#">www.camedu-learning.com</a>
                        </li>
                        <li>
                            <i class='bx bx-map'></i>
                            <a href="#" target="_blank">{{setting.address}}</a>
                        </li>
                    </ul>

                    <ul class="social-link">

                        <li><a href="{{setting.facebookLink}}" class="d-block" target="_blank"><i
                                    class='bx bxl-facebook'></i></a></li>
                        <!-- <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li> -->
                        <li><a href="{{setting.youtubeLink}}" class="d-block" target="_blank"><i
                                    class='bx bxl-youtube'></i></a></li>
                        <li><a href="{{setting.linkedInLink}}" class="d-block" target="_blank"><i
                                    class='bx bxl-linkedin'></i></a></li>
                        <li><a href="{{setting.telegramLink}}" class="d-block" target="_blank"><i
                                    class='bx bxl-telegram'></i></a></li>
                        <li><a href="{{setting.tiktokLink}}" class="d-block" target="_blank">
                            <i>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74a2.89 2.89 0 0 1 2.31-4.64a2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
                            </i></a></li>
                                    
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>{{aboutEdu}}</h3>

                    <ul class="support-link">
                        <li><a routerLink="/other/profile">{{aboutUs}}</a></li>
                        <li><a routerLink="/instructors">{{instructor}}</a></li>
                        <li><a href="javscript:;">{{feedback}}</a></li>
                        <li><a routerLink="/knowledges">{{knowledge}}</a></li>
                        <li><a routerLink="/contact">{{contact}}</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>{{usingCamedu}}</h3>

                    <ul *ngIf="isLoggedIn else elseBlock" class="useful-link">
                        <li><a routerLink="/my-account/dashboard">{{myAccount}}</a></li>
                        <li><a routerLink="/other/how-to-pay">{{howToPay}}</a></li>
                        <li><a routerLink="/lessons">{{englishLesson}}</a></li>
                        <li><a routerLink="/courses">{{courses}}</a></li>
                    </ul>

                    <ng-template #elseBlock>
                        <ul class="useful-link">
                            <li><a routerLink="/login">{{login}}</a></li>
                            <li><a routerLink="/register">{{register}}</a></li>
                            <li><a routerLink="/other/how-to-pay">{{howToPay}}</a></li>
                            <li><a routerLink="/lessons">{{englishLesson}}</a></li>
                            <li><a routerLink="/courses">{{courses}}</a></li>
                        </ul>
                    </ng-template>

                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Follow Us on Facebook Page</h3>

                    <div class="newsletter-box" style="padding-top:10px;">
                        <fb-page href="https://www.facebook.com/camedulearn/" height=300 smallHeader=true>Cam-Edu
                        </fb-page>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-bottom-area">
        <div class="container">
            <div class="logo">
                <a href="index-4.html" class="d-inline-block"><img src="assets/img/black-logo.png" alt="image"></a>
            </div>
            <p><i class='bx bx-copyright'></i>2026 <a href="index-4.html" target="_blank">Cam-Edu</a>. All
                rights
                reserved. | Designed By <a href="http://camgotech.com/" target="_blank">www.camgotech.com</a> </p>
        </div>
    </div>
</footer>
<!-- End Footer Area -->
<div class="go-top"><i class='bx bx-up-arrow-alt'></i></div>


